export default "/bundles/assets/photoAdd_86bab4d5e6fb359f08b585af5cea2d02.png";